import { Group } from '@/components/_common';
import { useReportWorkOrderAdministrativePublic } from '@/core/domain/questReport/WorkOrder/WorkOder.hooks';
import { useReportGenerate } from '@/hooks';
import LayoutPublicHeader from '@/layouts/PublicLayout/components/PublicHeader';
import { Button, Spin } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import { AiOutlineFileDone } from 'react-icons/ai';
import { useRouteMatch } from 'react-router-dom';

const WorkOrderAdministrativeReport: React.FC = () => {
  const { params } = useRouteMatch<{
    token: string;
  }>();

  const administrativeReport = useReportWorkOrderAdministrativePublic();
  const reportGenerate = useReportGenerate();

  useEffect(() => {
    if (params) {
      downloadFile();
    }
  }, [params]);

  const downloadFile = async () => {
    const result = await administrativeReport.mutateAsync(params);

    reportGenerate.downloadFile({
      result,
      fileName: `relatorio-administrativo-${moment().format(
        'DDMMYYYYHHmmss',
      )}.pdf`,
    });
  };

  return (
    <>
      <LayoutPublicHeader />

      {administrativeReport.isLoading && (
        <Group
          position="center"
          align="center"
          gap={16}
          style={{ width: '100%', height: '100vh' }}
        >
          <Spin />
          <h4>Carregando...</h4>
        </Group>
      )}

      {!administrativeReport.isLoading && !!administrativeReport.data && (
        <Group
          position="center"
          align="center"
          gap={16}
          style={{ width: '100%', height: '100vh', padding: 24 }}
        >
          <div>
            <Group gap={16} position="center">
              <AiOutlineFileDone size={24} />
              <h3 style={{ margin: 0 }}>Concluído!</h3>
            </Group>
            <div style={{ textAlign: 'center', marginTop: 24 }}>
              <p>Verifique a pasta de downloads para abrir o documento.</p>
              <p>
                Se o documento não foi baixado, tente novamente pelo link
                abaixo.
              </p>
              <Button type="link" onClick={downloadFile}>
                Baixar documento
              </Button>
            </div>
          </div>
        </Group>
      )}
    </>
  );
};

export default WorkOrderAdministrativeReport;
